// extracted by mini-css-extract-plugin
export default {"zoomModal":"w2-z","image":"x2-z","button":"y2-z","isOverlayShown":"z2-z"};